export function groupPackageLines(items, keyOf) {
    const byInstance = new Map();
    for (const item of items) {
        if (!item.packageInstanceId)
            continue;
        byInstance.set(item.packageInstanceId, [...(byInstance.get(item.packageInstanceId) ?? []), item]);
    }
    const emitted = new Set();
    const rows = [];
    for (const item of items) {
        const instanceId = item.packageInstanceId;
        if (!instanceId) {
            rows.push({ kind: 'line', key: keyOf(item), item });
            continue;
        }
        if (emitted.has(instanceId))
            continue;
        emitted.add(instanceId);
        const members = byInstance.get(instanceId) ?? [item];
        const named = members.find((member) => member.package) ?? item;
        rows.push({
            kind: 'package',
            key: `package:${instanceId}`,
            instanceId,
            packageId: named.package?.id ?? named.packageId ?? null,
            code: named.package?.code ?? '',
            name: named.package?.name ?? 'Package',
            items: members,
        });
    }
    return rows;
}
//# sourceMappingURL=package-groups.js.map